import allSlotsData from 'config/slotsApiMapping.json';
import verticesOnFloor from 'config/verticesOnFloor';

export default function deriveShopTagsFromFloor(floorLvl) {
  const conditionReg = /[\w\d]{1,2}-(\d{1,3})$/g;
  const nodesOnMap = verticesOnFloor[floorLvl];

  let result = [];
  allSlotsData.forEach(({ id, floorLevel, svgId}) => {
    if (floorLevel === floorLvl) {
      // Extract the captured group
      const regxGrp = conditionReg.exec(id);
      // Reset the regex mutation
      conditionReg.lastIndex = 0;
      // Define the coordinates to split out content (shop tag)
      const definedNode = nodesOnMap.find(element => (element.id === svgId))
      if (regxGrp) {
        // Extract the content (shop tag) to display from regex group
        const slotNumber = regxGrp[1];
        const resultItem = {
          ...definedNode,
          slotNumber
        };
        result.push(resultItem);
      }
    }
  });
  return result;
};